export default "__VITE_ASSET__DMaHjCj7__"